import { useId } from 'react';
import { ChevronDown } from 'lucide-react';

/*
 * Native <details>/<summary> rather than the Radix accordion. Radix unmounts a closed
 * panel's content, so every answer was missing from the rendered page: crawlers and
 * answer engines saw questions with no answers while the FAQPage JSON-LD claimed them.
 * <details> keeps each answer in the DOM, collapsed by the browser, keyboard- and
 * screen-reader accessible without JavaScript. A shared `name` makes the group
 * exclusive (one open at a time), as the accordion was.
 */
export default function FAQ({ items, dark = false, testid = 'faq-section' }) {
  const group = useId();
  return (
    <div data-testid={testid} className="w-full">
      {items.map((item, i) => (
        <details key={i} name={group} className={`group border-b ${dark ? 'border-white/12' : 'border-navy/12'}`}>
          <summary
            data-testid={`faq-trigger-${i}`}
            className={`flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-left font-display text-lg sm:text-xl font-medium tracking-tight transition-colors [&::-webkit-details-marker]:hidden ${
              dark ? 'text-bone hover:text-steel-light' : 'text-navy hover:text-steel'
            }`}
          >
            {item.q}
            <ChevronDown className="h-4 w-4 shrink-0 opacity-60 transition-transform duration-200 group-open:rotate-180" aria-hidden="true" />
          </summary>
          <div className={`faq-answer pb-6 text-base leading-relaxed ${dark ? 'text-silver' : 'text-navy/65'}`}>{item.a}</div>
        </details>
      ))}
    </div>
  );
}
